import jsonExport from "jsonexport/dist";
import { downloadCSV } from "react-admin";
import { requestTypeAdminLabels } from "../../../lib/constants";

// #108 - curated Agents CSV export. Columns are exactly the union of the
// agent Show, Edit, and List screens; nothing else leaves in a report (no raw
// import rows, no payment internals, no normalized matching fields). SSN and
// DOB appear because they are on the screens; the server already strips them
// from non-admin responses, so a principal's export has them blank.
const headers = [
  "NPN",
  "First Name",
  "Last Name",
  "Preferred Name",
  "Email",
  "Commission Email",
  "Enrollment Email",
  "Phone",
  "Address",
  "City",
  "State",
  "ZIP",
  "Date of Birth",
  "SSN",
  "Direct Upline",
  "Advisor",
  "FSD",
  "Agent Standing",
  "Licensed States",
];

const standingLabel = (v) => (v ? requestTypeAdminLabels[v] || v : "");

const exporter = async (records, fetchRelatedRecords) => {
  const agencies = await fetchRelatedRecords(records, "agency", "agency");
  const data = records.map((a) => ({
    "NPN": a.npn || "",
    "First Name": a.firstName || "",
    "Last Name": a.lastName || "",
    "Preferred Name": a.preferredName || "",
    "Email": a.email || "",
    "Commission Email": a.commissionEmail || "",
    "Enrollment Email": a.enrollmentEmail || "",
    "Phone": a.phone || "",
    "Address": a.addressStreet || "",
    "City": a.addressCity || "",
    "State": a.addressState || "",
    "ZIP": a.addressZip || "",
    "Date of Birth": a.dob || "",
    "SSN": a.ssn || "",
    "Direct Upline": agencies[a.agency]?.name || "",
    "Advisor": a.advisor || "",
    "FSD": a.fsd || "",
    "Agent Standing": standingLabel(a.declaredRequestType),
    "Licensed States": (a.licensedStates || []).join(", "),
  }));
  const report = await jsonExport(data, { headers });
  return downloadCSV(report, "Agents");
};

export default exporter;
